import { goLogin } from './utils';
class User {
    private tokenKey = 'HRTPS_GROUP_INTERVIEW_ADMIN_USER_TOKEN';
    private store: any = window.localStorage;
    getToken() {
        return this.store && this.store.getItem(this.tokenKey);
    }
    setToken(token: string) {
        this.store && this.store.setItem(this.tokenKey, token);
    }
    removeToken() {
        this.store && this.store.removeItem(this.tokenKey);
    }
    async logout() {
        this.removeToken();
        goLogin();
    }
}
export default new User();
